import { render, staticRenderFns } from "./AccomodationForm.vue?vue&type=template&id=97945254"
import script from "./AccomodationForm.vue?vue&type=script&lang=ts"
export * from "./AccomodationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports